<template>
  <div>
    <v-container fluid>
      <v-card elevation="0" class="pa-0">
        <v-card-title class="ma-0 pa-0">
          <v-row justify="end" no-gutters class="ma-0">
            <v-col cols="12">
              <h3 class="my-2 mx-2 primary--text">
                {{ $t("settings.currency.title") }}
              </h3>
            </v-col>
            <!-- <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer> -->
            <v-col cols="4">
              <v-text-field
                :label="$t('common.search')"
                v-model="search"
                :placeholder="$t('settings.currency.title')"
                class="mx-2"
                outlined
                dense
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-title>
        <v-data-table
          :footer-props="{ 'items-per-page-options': [50, 100, 150, 200, -1] }"
          id="currencyTable"
          :hide-default-footer="footer"
          :headers="headers"
          :items="currencyLists"
          :search="search"
          :loading="loading"
          mobile-breakpoint="0"
          :options.sync="options"
          class="pa-0 mt-2 datatable"
          :server-items-length="totalCurrency"
        >
          <!-- for subArea expand table  -->
          <!-- :expanded.sync="expanded"
          show-expand
          single-expand
          item-key="_id" -->
          <template v-slot:[`item._id`]="{ item }">
            <p class="my-0 py-0">
              {{
                options.page * options.itemsPerPage -
                  options.itemsPerPage +
                  currencyLists
                    .map(function(x) {
                      return x._id;
                    })
                    .indexOf(item._id) +
                  1
              }}
            </p>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-row class="mx-auto" justify="center">
              <v-icon color="primary" class="mx-2" @click="editCurrency(item)"
                >mdi-pencil</v-icon
              >
            </v-row>
          </template>
          <template v-slot:[`item.isActive`]="{ item }">
            <v-row class="mx-auto" justify="center">
              <v-switch
                v-if="!footer"
                v-model="item.isActive"
                @change="toggleCurrency(item)"
              >
              </v-switch>
              <span v-else>{{ item.isActive ? "true" : "false" }}</span>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import { toggleCurrency } from "../methods/currency/toggle_currency_status";
export default {
  data() {
    return {
      expanded: [],
      loading: false,
      footer: false,
      search: "",
      variables: {
        limit: 10,
        skip: 0
      },
      options: {
        itemsPerPage: 50,
        page: 1
      },
      currencyLists: [],
      totalCurrency: 10
    };
  },
  computed: {
    headers() {
      return [
        {
          text: "#",
          align: this.$vuetify.rtl ? "right" : "left",
          value: "_id",
          sortable: false,
          width: 10
        },
        {
          text: this.$t("settings.currency.title"),
          align: this.$vuetify.rtl ? "right" : "left",
          value: "currency",
          sortable: false,
          width: 100
        },
        {
          text: `${this.$t("settings.currency.title")} (${this.$t('common.en')})`,
          align: this.$vuetify.rtl ? "right" : "left",
          value: "nameEn",
          sortable: false,
          width: 100
        },
         {
          text: `${this.$t("settings.currency.title")} (${this.$t('common.ar')})`,
          align: this.$vuetify.rtl ? "right" : "left",
          value: "nameAr",
          sortable: false,
          width: 100
        },
        // {
        //   text: `${this.$t("settings.currency.countryCode")}`,
        //   align: this.$vuetify.rtl ? "right" : "left",
        //   value: "countryCode",
        //   sortable: false,
        //   width: 100
        // },{
        //   text: `${this.$t("settings.currency.currencyRate")}`,
        //   align: this.$vuetify.rtl ? "right" : "left",
        //   value: "currencyRate",
        //   sortable: false,
        //   width: 100
        // },{
        //   text: `${this.$t("settings.currency.symbol")}`,
        //   align: this.$vuetify.rtl ? "right" : "left",
        //   value: "symbol",
        //   sortable: false,
        //   width: 100
        // },
        {
          text: this.$t("settings.currency.status"),
          align: this.$vuetify.rtl ? "right" : "left",
          value: "isActive",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("settings.currency.decimalPlaces"),
          align: this.$vuetify.rtl ? "right" : "left",
          value: "decimalPlaces",
          sortable: false,
          width: 100
        },
        {
          text: this.$t("common.actions"),
          value: "actions",
          sortable: false,
          align: this.$vuetify.rtl ? "right" : "left",
          width: 100
        }
      ].map(header => {
        header.align = "center";
        return header;
      });
    }
  },
  watch: {
    search(val) {
      this.loading = true;
      this.$apollo.queries.getAllCurrencyForAdmin.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalCurrency,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: val
        }
      });
      this.loading = false;
    },
    options() {
      this.$apollo.queries.getAllCurrencyForAdmin.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalCurrency,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: this.search
        }
      });
    }
  },
  apollo: {
    getAllCurrencyForAdmin() {
      this.loading = true;
      return {
        query: require("@/settings/api/queries/currency/get_all_currencies.graphql"),
        variables: {
          input: {
            limit: this.totalCurrency,
            skip: 0
          },
          filter: {
            searchKey: this.search
          }
        },
        result({ data, loading }) {
          // , loading, networkStatus, refetch
          this.currencyLists = this.$format.cloneVariable(
            data.getAllCurrencyForAdmin.currencies
          );
          this.loading = loading;
          this.totalCurrency = data.getAllCurrencyForAdmin.totalCount;
        }
      };
    }
  },
  mounted() {
    this.$root.$on("toggleItems", data => {
      if (data.module === "currency") {
        toggleCurrency({
          id: data.item._id,
          status: data.item.isActive
        }).then(({ data }) => {
          if (data.toggleCurrency) {
            this.$store.commit("TOGGLE_BTN_LOADING", false);
            this.$root.$emit("snackbar", {
              snackbar: true,
              text: "Currency Status Changed Successfully",
              color: "green"
            });
            this.$root.$emit("refetchCurrency");
          }
        });
      }
    });
    this.$root.$on("currencyTable", () => {
      this.options.itemsPerPage = 50;
      this.$set(this.options, this.options.itemsPerPage, 50);
    });
    this.$root.$on("refetchCurrency", () => {
      this.loading = true;
      this.$apollo.queries.getAllCurrencyForAdmin.refetch({
        input: {
          limit:
            this.options.itemsPerPage !== -1
              ? this.options.itemsPerPage
              : this.totalCurrency,
          skip:
            this.options.page * this.options.itemsPerPage -
            this.options.itemsPerPage
        },
        filter: {
          searchKey: ""
        }
      });
      this.loading = false;
    });
    this.$root.$on("searchCurrency", data => {
      this.search = data;
    });
    this.$root.$on("exportCurrency", () => {
      this.exportData();
    });
  },
  methods: {
    showRightSideDrawer(item) {
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
      this.$store.commit("APP_SETTINGS_FORMNAME", item);
    },
    exportData() {
      this.$apollo.queries.getAllCurrencyForAdmin
        .refetch({
          limit: 0,
          skip: 0
        })
        .then(response => {
          this.options.itemsPerPage =
            response.data.getAllCurrencyForAdmin.totalCount;
          this.currencyLists = response.data.getAllCurrencyForAdmin.currencies;
          this.footer = true;
          setTimeout(() => {
            this.htmlToExcel("currencyTable", "currencies");
          }, 1000);
        });
    },
    toggleCurrency(item) {
      this.$root.$emit("toggleDialog", {
        dialog: true,
        item: item,
        module: "currency"
      });
    },
    editCurrency(item) {
      this.$store.commit("IS_EDIT_CURRENCY", true);
      this.$store.commit("EDIT_CURRENCY", item);
      this.$store.commit("APP_SETTINGS_FORMNAME", "CURRENCY");
      this.$store.commit("SHOW_RIGHTSIDE_DRAWER", true);
    }
  },
  beforeDestroy() {
    this.$root.$off("deleteItems");
    this.$root.$off("currencyTable");
    this.$root.$off("refetchCurrency");
    this.$root.$off("exportCurrency");
    this.$root.$off("searchCurrency");
    this.$root.$off("toggleItems");
  }
};
</script>
<style scoped>
.custom-data-table {
  background: #ffffff !important;
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2) !important;
}
.datatable >>> .v-data-footer__select {
  direction: ltr !important;
}
.datatable >>> .v-data-footer__pagination {
  direction: ltr !important;
}
</style>
